/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AccessViolationsByCloudAccountWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("AccessViolationsByCloudAccountWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return AccessViolationsByCloudAccountWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<AccessViolationsByCloudAccountWidgetConfiguration>): AccessViolationsByCloudAccountWidgetConfiguration {
        let obj = Object.assign(new AccessViolationsByCloudAccountWidgetConfiguration(), model);
        AccessViolationsByCloudAccountWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AccessViolationsByCloudAccountWidgetConfiguration>): AccessViolationsByCloudAccountWidgetConfiguration {
        if (!model) return null;
        return AccessViolationsByCloudAccountWidgetConfiguration.newInstance(<AccessViolationsByCloudAccountWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AccessViolationsByCloudAccountWidgetConfiguration) {
        if (!obj) return;

        models.AccessViolationsByCloudAccountWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AccessViolationsByCloudAccountWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AccessViolationsByCloudAccountWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
